// src/components/PopupMessage.jsx
import React, { useEffect } from 'react';
import './PopupMessage.css';

const PopupMessage = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000); // auto-hide after 3s
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`popup-message ${type}`}>
      {message}
    </div>
  );
};

export default PopupMessage;
